import React, { useContext } from "react";
import { View, Text, StyleSheet } from "react-native";
import { useColorScheme } from "react-native-appearance";
import { colors } from "../context/Colors";
import Icon from "react-native-vector-icons/Ionicons";
// import HTMLView from "react-native-htmlview";
// import linkifyHtml from "linkifyjs/html";
import AppContext from "../context";

export default function RewardRules({ rules }) {
  const theme = useColorScheme() === "dark" ? "dark" : "light";
  const { dict } = useContext(AppContext);
  if (!rules) return null;
  return (
    <View
      style={{
        borderWidth: 2,
        borderColor: colors[theme].gamePreamble,
        borderRadius: 10,
        marginTop: 10,
        backgroundColor: colors[theme].bg,
        flexDirection: "row",
        alignItems: "center",
      }}
    >
      <View
        style={{
          backgroundColor: colors[theme].gamePreamble,
          padding: 5,
          marginRight: 5,
          alignSelf: "stretch",
          justifyContent: "center",
        }}
      >
        <Icon
          size={28}
          name="information-circle-outline"
          color={colors[theme].text}
          style={{ opacity: 0.5 }}
        />
      </View>
      <View style={{ flex: 1, padding: 10 }}>
        <Text
          style={{
            color: colors[theme].text,
            fontSize: 20,
            fontWeight: "500",
            marginBottom: 10,
          }}
        >
          {dict.claim_your_reward}
        </Text>
        <div>${rules}</div>
        {/* <HTMLView
          value={linkifyHtml(`<div>${rules}</div>`)}
          stylesheet={{
            div: { color: colors[theme].text },
            a: {
              fontWeight: "500",
              color: "#23A7F1",
            },
          }}
        /> */}
      </View>
    </View>
  );
}
